import { useTranslation } from "react-i18next";
import { Power } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";
import { Switch } from "../../../components/ui/switch";

// زر تشغيل/إيقاف التحيات الصوتية على مستوى المنصة كلها — لمالك المنصة للسيطرة على استهلاك الرصيد.
export const VoiceEnableToggle = ({ enabled, busy, onChange }) => {
  const { t } = useTranslation();
  return (
    <NeuCard data-testid="greeting-enable-card">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <span
            className={`mt-0.5 rounded-full p-2 shadow-neu-sm ${enabled ? "text-primary" : "text-muted-foreground"}`}
          >
            <Power className="h-4 w-4" />
          </span>
          <div>
            <p className="label-xs">{t("greeting.enableTitle")}</p>
            <p className="mt-1 text-[11px] text-muted-foreground">{t("greeting.enableHint")}</p>
          </div>
        </div>
        <Switch
          checked={!!enabled}
          disabled={busy}
          onCheckedChange={onChange}
          data-testid="greeting-enable-switch"
        />
      </div>
    </NeuCard>
  );
};
